import { render, staticRenderFns } from "./QuizChoice.vue?vue&type=template&id=21e9df6f"
import script from "./QuizChoice.vue?vue&type=script&lang=js"
export * from "./QuizChoice.vue?vue&type=script&lang=js"
import style0 from "./QuizChoice.vue?vue&type=style&index=0&id=21e9df6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports